export default "__VITE_ASSET__D7Lr7Y2k__"